import React, { useEffect, useState } from "react";
import { DynIcon } from "@/components/site/DynIcon";
import { T } from "@/context/LanguageContext";

export function PlaceNav({ tabs }) {
  const [active, setActive] = useState(tabs?.[0]?.key);
  const [subH, setSubH] = useState(52);

  useEffect(() => {
    const measure = () => {
      const el = document.querySelector('[data-testid="place-subnav"]');
      setSubH(el ? Math.round(el.getBoundingClientRect().height) : 52);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  useEffect(() => {
    const ids = tabs.map((t) => `tab-${t.key}`);
    const obs = new IntersectionObserver(
      (entries) => {
        const vis = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (vis[0]) setActive(vis[0].target.id.replace("tab-", ""));
      },
      { rootMargin: `-${subH + 10}px 0px -70% 0px`, threshold: 0 }
    );
    ids.forEach((id) => { const el = document.getElementById(id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, [tabs, subH]);

  const go = (t) => {
    const el = document.getElementById(t.target || `tab-${t.key}`);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - subH - 12;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    setActive(t.key);
  };

  return (
    <div className="sticky top-0 z-30 border-b border-border bg-white/95 shadow-sm backdrop-blur-md" data-testid="place-subnav">
      <div className="no-scrollbar mx-auto flex max-w-[1500px] items-stretch gap-1 overflow-x-auto px-3">
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => go(t)}
            className={`flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-3 text-[13px] font-semibold uppercase tracking-wide transition-colors ${
              active === t.key
                ? "border-oldglory-red text-navy"
                : t.accent
                  ? "border-transparent text-[#b7791f] hover:text-[#8a5a12]"
                  : "border-transparent text-muted-foreground hover:text-navy"
            }`}
            data-testid={`subnav-${t.key}`}
          >
            <DynIcon name={t.icon} className="h-4 w-4" />
            <T>{t.label}</T>
          </button>
        ))}
      </div>
    </div>
  );
}
